import React from "react";
import styled from "styled-components";
import { colors2, UI_HELPTEXT } from "oolib";
import { DisplayIcon } from "oolib/dist/utils/comps/DisplayIcon";

// Warning notice — matches the app-wide warning convention
const StyledWarningNotice = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.6rem;
  border-radius: 0.6rem;
  color: ${colors2.yellow};
  background: ${colors2.yellowBG};
  border: 1px solid ${colors2.yellowStroke};
`;

/**
 * Inline yellow warning: a filled WarningDiamond followed by helptext. Used by
 * the direct-import column-type selector's inline reminders and the Verify
 * Mapping modal's no-date-field nudge, so the two can't drift.
 *
 * @prop {node}   children  the message.
 * @prop {object} style     extra styles on the container (e.g. a margin).
 */
export const WarningNotice = ({ children, style }) => (
  <StyledWarningNotice style={style}>
    <DisplayIcon
      size={12}
      icon="WarningDiamond"
      weight="fill"
      color={colors2.yellow}
      style={{ flexShrink: 0 }}
    />
    <UI_HELPTEXT style={{ color: colors2.yellow }}>{children}</UI_HELPTEXT>
  </StyledWarningNotice>
);

export default WarningNotice;
